import Vue from 'vue'
import { USER_INFO, ACCESS_TOKEN, REFERRER } from '../mutation-types'
import { getUserInfoByHideCode, getUserActionConfig, logout, transformLoginByOther, selMuchTransformLogin, GetPersonalUserSub, QueryThirdSystemList } from '@/api/sso/user'
import { getUserOnlineSubCodeEncry } from '@/api/sso/subject'
import { queryMsgNoticePage, queryClassification, getNoticeMuteTime, QuerySystemParamsPage } from '@/api/index'
import { clearVueLs } from '@/store/_util/util'
import { getServiceCurrentDomainDetail } from '@/api/sso/role'
import { axios } from '@/api/sellerwell/request'
import { saveToLocal } from '@/utils/storage'

const user = {
  state: {
    token: '',
    referrer: '',
    notification: {}, // 未读消息提醒
    messageClassification: [], // 用户消息分类列表
    info: {}, // 用户信息
    config: {}, // 用户配置
    systemCodes: [], // 所有能用的systemCode
    authLoginParams: {}, // 授权登录临存信息
    needBack: false, // 退出时 是否返回 原来跳转我们的网站时的登录地址，如果false,就返回我们自己的登录页，true，就返回他们的登录页
    guidePageProcess: {}, // 引导页进度，没有则强制进入引导页
    test: 0
  },
  mutations: {
    SET_TOKEN: (state, token) => {
      state.token = token
      Vue.ls.set(ACCESS_TOKEN, token)
    },
    SET_REFERRER: (state, referrer) => {
      state.referrer = referrer
      Vue.ls.set(REFERRER, referrer)
    },
    SET_NOTIFICATION: (state, notification) => {
      state.notification = notification
    },
    SET_USER_INFO (state, info) {
      state.info = { ...info }
      Vue.ls.set(USER_INFO, info)
      Vue.ls.set('company_id', info.subjectCodeEncrypt)
    },
    SET_USER_CONFIG (state, config) {
      state.config = config
    },
    SET_MESSAGE_CLASSIFICATION (state, message) {
      state.messageClassification = message
    },
    SET_AUTH_LOGIN_PARAMS (state, params) {
      state.authLoginParams = params
    },
    SET_SYSTEM_CODES: (state, codes) => {
      state.systemCodes = codes
    },
    SET_GUIDE_PAGE_PROCESS (state, guidePageProcess) {
      state.guidePageProcess = guidePageProcess
      saveToLocal('pro__guide_process', guidePageProcess)
    }
  },
  actions: {
    // 根据token自动登录
    AutoLogin ({ commit, dispatch }, query) {
      const { token, needBack, systemCode, resource } = query
      const referrer = window.document.referrer
      if (resource === 'SELMUCH_ADS') {
        return new Promise((resolve) => {
          selMuchTransformLogin({ token }).then(({ data }) => {
            if (data?.token) {
              commit('SET_TOKEN', data.token)
              resolve()
            }
          })
        })
      }
      switch (systemCode) {
        case 'KJY':
          return dispatch('TransformLoginByOther', query)
        default: {
          commit('SET_TOKEN', token)
          needBack && commit('SET_REFERRER', referrer)
          return new Promise((resolve, reject) => {
            GetPersonalUserSub({})
              .then(resolve)
              .catch(() => {
                clearVueLs(Vue)
                if (needBack) {
                  setTimeout(() => {
                    window.location.href = referrer
                  }, 3000)
                }
                reject(needBack)
              })
          })
        }
      }
    },
    // 根据第三方token自动登录
    TransformLoginByOther ({ commit }, query) {
      const params = {
        systemCode: query.systemCode,
        token: query.token
      }
      return transformLoginByOther(params).then(({ data }) => {
        commit('SET_TOKEN', data)
      })
    },
    GetUserInfo ({ commit, state, dispatch, rootGetters }, { reset = false, serviceId = '' } = {}) {
      if (!Vue.ls.get(ACCESS_TOKEN)) return
      if (reset) Vue.ls.remove(USER_INFO)
      return new Promise(async (resolve, reject) => {
        try {
          if (!state.messageClassification?.length) {
            dispatch('queryClassification')
          }
          if (!state.systemCodes?.length) {
            dispatch('GetSystemCodes')
          }
          let info = Vue.ls.get(USER_INFO)
          if (!info) {
            const res = await getUserInfoByHideCode()
            let { dataList } = await QuerySystemParamsPage({ 'systemGroup': 'SYSTEM_PARAMS', 'systemName': 'SSO_ENV_LIST' })
            dataList = dataList || [{ systemValue: '[{"label":"正常","value":"sso"},{"label":"灰度V1","value":"v1"}]' }]
            info = { ...res.data, ssoEnvList: JSON.parse(dataList[0]?.systemValue || '[]') }
            commit('SET_USER_INFO', info)
          }
          // 引导页进度
          if (reset && serviceId) {
           await dispatch('getGuideProcess', { serviceId })
          }
          // 重命名网页标题
          // document.title = (info.onlineSubjectName || '') + '-易仓科技用户中心'
          document.title = (info.onlineSubjectName || '') + (rootGetters.currentLang === 'zh_CN' ? '-易仓科技用户中心' : '-ECCANG')
          resolve(info)
        } catch (e) {
          reject(e)
        }
      })
    },
    getGuideProcess({ commit, state, rootGetters }, params) {
      return new Promise(async (resolve, reject) => {
        const serviceId = rootGetters.serviceId ? rootGetters.serviceId : params.serviceId
        const { data } = await getServiceCurrentDomainDetail({ serviceId })
        const { domain } = (data?.serviceCurrentDomainDTOList || []).find(({ systemCode }) => systemCode === 'WMS_MANAGER')
        // console.log('baseURL', data)
        // console.log(' window.location.href', window.location.href.includes('http://') && !domain.includes('http://'))
        const baseURL = window.location.href.includes('https://')
          ? domain.replace('http://', 'https://')
          : domain
        const { data: guidePageData } = await axios.post(
          '/openapi/system/guide-page/process',
          { gp_code: 'light_weight_sail' },
          { baseURL }
        )
        commit('SET_GUIDE_PAGE_PROCESS', guidePageData)
        resolve()
      })
    },
    GetSystemCodes ({ commit }) {
      return new Promise((resolve, reject) => {
        QueryThirdSystemList({
          parentSystemCode: 'ROOT'
          // service_show: 1
        }).then(({ data }) => {
          commit('SET_SYSTEM_CODES', [...data, {
            systemCode: 'ORDER_MANAGER',
            parentSystemCode: 'ERP',
            systemId: 1000,
            systemName: 'ERP',
            systemNameEn: 'ERP'
          }])
          resolve()
        }).catch((err) => {
          reject(err)
        })
      })
    },
    GetUserConfig ({ commit, state }) {
      if (!Vue.ls.get(ACCESS_TOKEN)) return
      return new Promise(async (resolve, reject) => {
        try {
          const { data } = await getUserActionConfig()
          if (data) {
            commit('SET_USER_CONFIG', {
              ...data,
              saveMenuStatus: !!(data.menuStatusDTO.saveMenuStatus === 'true'), // 获取用户状态（展开|收缩左侧菜单开关）
              menuStatusDTO: undefined,
              listingShow: data.listingShow === -1 ? true : data.listingShow,
              packageStyle: data.packageStyle || '2'
            })
          }
          resolve(state.config)
        } catch (e) {
          reject(e)
        }
      })
    },
    Logout () {
      const referrer = Vue.ls.get(REFERRER)
      // console.log('referrer', referrer, window.location.pathname)
      return new Promise((resolve) => {
        if (window.location.pathname.startsWith('/login')) {
          clearVueLs(Vue)
          // window.location.href = '/login' + (window.location['search'] || '')
          return resolve()
        }
        logout()
          .finally(() => {
            clearVueLs(Vue)
            localStorage.removeItem('X-Auth-Token') // 清空amazon运营登陆状态
            let redirectPath = ''
            if (location.hash) {
              redirectPath = '?redirectPath=' + encodeURIComponent(location.pathname.substring(location.pathname.lastIndexOf('/')) + location.hash)
            }
            window.location.href = referrer || ('/login' + redirectPath)
            resolve()
          })
      })
    },
    ClearDateAfterLogout () {
      clearVueLs(Vue, { clearAll: true })
      console.log('ClearDateAfterLogout')
      window.sessionStorage.removeItem('firstCreateTipsFlag')
      window.sessionStorage.removeItem('amz_listing_set_guide_modal')
      document.title = '易仓科技用户中心' // 浏览器标题恢复：易仓用户中心
    },
    OpenSaleConsult ({ commit }, systemCode = 'ERP') {
      getUserOnlineSubCodeEncry({ systemCode: 'SSO_SYS_USER' }).then(res => {
        const { subjectCodeEncrypt, companyName, packageInfoOnlineDTOS } = res.data
        const { phone, nickName, userId } = Vue.ls.get(USER_INFO)
        const origin = 'https://im.7x24cc.com/phone_webChat.html'
        const chatIdMap = {
          ERP: '1bb826d2-26de-4628-a252-38cd41176060',
          SYS_LISTING: '3dbf76e2-7f7c-42a5-be55-e8942d1588a3',
          AMAZON_OPERATE: 'bbe43831-c731-4ad3-9163-4e584ba321dc',
          M2B: 'ba09a5df-d7d9-4f9a-8918-516ae619ae29',
          WMS: 'c784a961-c3d9-411b-abac-f73d8456c7f4',
          TMS: '809a62a8-7c65-4686-99ee-fe7f73d5bee8'
        }
        const defaultChatID = chatIdMap['ERP']
        const packageNames = packageInfoOnlineDTOS instanceof Array ? '-套餐: ' + packageInfoOnlineDTOS.map(item => item.packageName).join('、') : ''
        const packageIds = packageInfoOnlineDTOS instanceof Array ? packageInfoOnlineDTOS.map(item => item.packageId).join('z') : ''
        const data = {
          accountId: 'N000000020843',
          AgentId: '7c4f05b0-e1e7-11ea-b302-9578a53c6dc9',
          nickName: (companyName || phone || nickName) + packageNames,
          chatId: chatIdMap[systemCode] || defaultChatID,
          visitorId: subjectCodeEncrypt + userId + packageIds
        }
        const URL = `${origin}?${Object.keys(data).map(key => `${key}=${data[key]}`).join('&')}`

        window.open(URL, '_blank')
      })
    },
    // 获取未读消息 & 未读总数
    queryMsgNoticePage ({ commit }) {
      queryMsgNoticePage({
        hasRead: 2,
        pageSize: 4
      }).then(({ dataList, noReadCount }) => {
        commit('SET_NOTIFICATION', { dataList, noReadCount })
      })
    },
    async queryClassification ({ commit, state }) {
      const { dataList } = await queryClassification({ paging: false, messageStatus: 1 })
      const { data } = await getNoticeMuteTime({ })
      const noticeMuteTimes = (data || []).reduce((acc, cur) => {
        return {
          ...acc,
          [cur.messageType]: {
            beginTime: cur.beginTime,
            endTime: cur.endTime,
            isNextDay: Boolean(cur.beginTime - cur.endTime)
          }
        }
      }, {})
      const messageClassification = dataList.map(({ classificationEnName, classificationKrName, classificationName, id, messageType, messageIcon }) => {
        return {
          classificationEnName,
          classificationKrName,
          classificationName,
          id,
          messageType,
          messageIcon,
          ...noticeMuteTimes[messageType]
        }
      })
      commit('SET_MESSAGE_CLASSIFICATION', messageClassification)
    }
  }
}

export default user
